/* eslint-disable camelcase */
import React from 'react';
import {
  Formik,
  Field,
} from 'formik';

import {
  Button,
  TextField,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

type Props = {
  onSubmit: { (data: any): void },
};

const CouponForm = ({ onSubmit }: Props) => (
  <Flex
    shrink={0}
    padding="5% calc(15% + 10px)"
    width="calc(100% + 20px)"
    borderBottom="1px solid #ccc"
  >
    <Formik
      enableReinitialize
      initialValues={{
        coupon: '',
      }}
      onSubmit={onSubmit}
    >
      {({ handleSubmit }) => (
        <Flex
          column
          justify="center"
          align="center"
          fillSpace
          as="form"
          onSubmit={handleSubmit}
        >
          <Field
            name="coupon"
            color="#333"
            label="Coupon"
            height="38px"
            spacing="none"
            component={TextField}
            autoComplete="off"
            margin="0 0 15px 0"
          />
          <Flex
            row
            justify="space-around"
            width="100%"
          >
            <Button
              type="submit"
              appearance="primary"
            >
              Apply
            </Button>
          </Flex>
        </Flex>
      )}
    </Formik>
  </Flex>
);

export default CouponForm;
